<div class="sc-uploader" [ngClass]="{
        'sc-uploader_status': view == 'list',
        'sc-uploader_status_valid': items.length > 0,
        'sc-uploader_status_invalid': hasError
        }">
    <div *ngIf="showLabel" class="sc-uploader__images-loaded-label">
        <span *ngIf="maxFiles > 1 && loadingList(items,false).length">
            {{loadingList(items,false).length}} foto{{loadingList(items,false).length > 1 ? 's' : ''}} cargada{{loadingList(items,false).length > 1 ? 's' : ''}}:
        </span>
    </div>
    <div class="sc-uploader__thumbnail-container" *ngIf="view=='thumbnail'">
        <div *ngFor="let item of items; let i = index;" class="sc-uploader__image-item">
            <div class="sc-uploader__image-container">
                <div class="sc-uploader__thumbnail-loading" *ngIf="!item.errorMessage && (item.loading || item.thumbnailLoading)"></div>
                <sc-icon class="sc-uploader__thumbnail-loading-icon" icon="loading" *ngIf="!item.errorMessage && (item.loading || item.thumbnailLoading)"></sc-icon>
                <div class="sc-uploader__thumbnail-error" *ngIf="item.errorMessage">
                    <span class="sc-uploader__thumbnail-error-message text-truncate">{{item.errorMessage}}</span>
                </div>
                <sc-icon class="sc-uploader__thumbnail-error-icon" icon="close-elipse" *ngIf="item.errorMessage"></sc-icon>
                <img alt="Imagen subida" class="sc-uploader__thumbnail-image" *ngIf="!item.errorMessage" [src]="item.thumbnail" (load)="handleThumbnailLoad(item)">
            </div>
            <div class="sc-uploader__image-name text-truncate">{{item.name}}</div>
            <div class="sc-uploader__image-detail">
                <div class="sc-uploader__image-size text-truncate">
                    <span *ngIf="item.size">{{item.size | fileSize}}</span>
                </div>
                <sc-icon *ngIf="!item.loading && item.retry" class="sc-uploader__retry-icon" icon="refresh" (click)="retryUploadFile(item)"></sc-icon>
                <sc-icon *ngIf="!item.loading" class="sc-uploader__delete-icon" icon="trash" (click)="deleteFile(item)"></sc-icon>
            </div>
        </div>
    </div>
    <div class="sc-uploader__header header-box" *ngIf="view=='list'">
        <div class="header-box__title">{{title}}</div>
        <div class="header-box__subtitle">{{subtitle}}</div>
        <div class="header-box__button">
            <button
                id="btn-upload-{{id}}"
                class="sc-upload-button"
                (click)="fileInput.click() && $event.stopPropagation()"
                [disabled]="disabled || items.length >= maxFiles">
                {{addButtonText}}
            </button>
        </div>
    </div>

    <div class="sc-uploader__info" *ngIf="view=='list' && info">
        <sc-box type='info' [content]="info"></sc-box>
    </div>

    <div class="sc-uploader__list-container" *ngIf="view=='list'">
        <div *ngFor="let item of items.slice().reverse(); let i = index;" class="sc-uploader__item d-flex" [ngClass]="{'sc-uploader__item--document': !item.typeImage, 'sc-uploader__item--errored': item.errorMessage, 'sc-uploader__item--multiple': multiple}">
            <div class="sc-uploader__item-left d-flex align-items-center justify-content-center">
                <div class="sc-uploader__thumbnail-loading" *ngIf="!item.errorMessage && (item.loading || item.thumbnailLoading)"></div>
                <sc-icon class="sc-uploader__thumbnail-loading-icon" icon="loading" *ngIf="!item.errorMessage && (item.loading || item.thumbnailLoading)"></sc-icon>
                <div class="sc-uploader__thumbnail-error" *ngIf="item.errorMessage">
                    <sc-icon class="sc-uploader__thumbnail-error-icon" icon="close-elipse"></sc-icon>
                </div>
                <div class="sc-uploader__thumbnail-file" *ngIf="!item.typeImage">
                    <sc-icon [icon]="item.type === 'application/pdf' ? 'pdf-document' : 'uniE91D'" size="1_5"></sc-icon>
                </div>
                <img alt="Imagen Subida" class="sc-uploader__thumbnail-image" *ngIf="shouldShowImageThumbnail && item.typeImage" [src]="item.thumbnail" (load)="handleThumbnailLoad(item)">
            </div>
            <div class="sc-uploader__item-center text-truncate">
                <div class="align-self-center text-truncate">
                    <p class="sc-uploader__item-center-title m-0">
                        <span class="text-truncate">{{getFileNameWithoutExt(item.name)}}</span>.{{getFileExtension(item.name)}}
                    </p>
                    <p class="sc-uploader__item-center-size m-0 text-truncate" *ngIf="!item.errorMessage">
                        <span *ngIf="item.size && !item.loading">{{item.size | fileSize}}</span>
                        <span *ngIf="item.loading">{{loadingText}}</span>
                    </p>
                    <p class="sc-uploader__item-center-error-message m-0 text-truncate" *ngIf="item.errorMessage">
                        <span class="sc-uploader__item-center-error-message-info">{{item.size | fileSize}} -</span> {{item.errorMessage}}
                    </p>
                </div>
            </div>
            <div class="sc-uploader__item-right">
                <div class="sc-uploader__image-detail" [ngClass]="{ 'sc-uploader__image-detail_disabled': disabled }">
                    <sc-icon *ngIf="!item.loading && item.retry" class="sc-uploader__retry-icon" icon="refresh" (click)="retryUploadFile(item)"></sc-icon>
                    <sc-icon *ngIf="!item.loading" class="sc-uploader__delete-icon" icon="trash" (click)="deleteFile(item)"></sc-icon>
                    <sc-icon *ngIf="hasCancel && item.loading && !item.isDelete" class="sc-uploader__cancel-icon" icon="close" (click)="cancelFile(item)"></sc-icon>
                </div>
            </div>
        </div>
    </div>

    <div class="sc-uploader__simple" *ngIf="view=='simple'">
        <sc-button
            class="mt-1"
            type="link-secondary"
            [id]="'sc-button-upload-'+id"
            (onClick)="fileInput.click() && $event.stopPropagation()"
            [disabled]="disabled"
            [loading]="isLoading">
            {{addButtonText}}
        </sc-button>
    </div>

    <div class="sc-uploader__error" [ngClass]="{ 'sc-uploader__error_show': hasErrorMessage }" *ngIf="multiple">
        <sc-box type="error" content="{{errorMessage}}"></sc-box>
    </div>
    <sc-button class="mt-1" [id]="'sc-button-upload-'+id" type="secondary" (onClick)="fileInput.click() && $event.stopPropagation()" *ngIf="(!maxFiles || items && items.length < maxFiles) && view === 'thumbnail'">
        {{addButtonText}}
    </sc-button>
    <input id="sc-uploader-{{id}}" hidden tabindex="-1" [disabled]="disabled" #fileInput [accept]="getAcceptType()" type="file" [placeholder]="placeholder" (change)="fileEvent($event)" [multiple]="multiple"/>
</div>
